import ContinueLink from "./ContinueLink"

export default ContinueLink
